import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  contact: yup.string().required(),
  detail: yup.string().required(),
});
